"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Notice = _interopRequireDefault(require("@rsuite/icon-font/lib/status/Notice"));

// Generated by script, don't edit it please.
var Notice = (0, _createSvgIcon["default"])({
  as: _Notice["default"],
  ariaLabel: 'notice',
  category: 'status',
  displayName: 'Notice'
});
var _default = Notice;
exports["default"] = _default;
module.exports = exports.default;